import React from 'react';

import { Skeleton, SkeletonTheme, UiKit } from 'components';

export default function Loader({ isLoading = false, children = null }) {
  if (!isLoading) return children;

  return (
    <SkeletonTheme className="m-0">
      <UiKit.Flex direction="column" gap={16}>
        <UiKit.Card>
          <UiKit.Card.Body>
            <UiKit.Flex align="center" gap={8}>
              <Skeleton circle width="16px" height="16px" />
              <Skeleton width="150px" height="16px" className="my-1" />
            </UiKit.Flex>
          </UiKit.Card.Body>
        </UiKit.Card>
        <UiKit.Card>
          <UiKit.Card.Body>
            <UiKit.Flex align="center" gap={8}>
              <Skeleton circle width="16px" height="16px" />
              <Skeleton width="200px" height="16px" className="my-1" />
            </UiKit.Flex>
          </UiKit.Card.Body>
        </UiKit.Card>
      </UiKit.Flex>
    </SkeletonTheme>
  );
}
